/* eslint-disable react/jsx-props-no-spreading */
import { useUrlGenerator } from '@folklore/routes';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'wouter';

import PageMeta from '../partials/PageMeta';

import styles from '../../../styles/pages/error.module.css';

const propTypes = {
    statusCode: PropTypes.number,
};

function ErrorPage({ statusCode = 404 }) {
    const url = useUrlGenerator();
    return (
        <div className={styles.container}>
            <PageMeta title={`Error ${statusCode}`} />
            <div className={styles.inner}>
                <h1 className={styles.title}>
                    {statusCode === 404 ? (
                        <FormattedMessage defaultMessage="Error 404" description="Error message" />
                    ) : (
                        <FormattedMessage defaultMessage="Error" description="Error message" />
                    )}
                </h1>
                <p className={styles.description}>
                    <FormattedMessage
                        defaultMessage="Sorry, we couldn't find this page"
                        description="Error message"
                    />
                </p>
                <p className={styles.actions}>
                    <Link href={url('home')}>
                        <FormattedMessage
                            defaultMessage="Go to home page"
                            description="Error message"
                        />
                    </Link>
                </p>
            </div>
        </div>
    );
}

ErrorPage.propTypes = propTypes;

export default ErrorPage;
